<template>
  <el-container style="height:100%">
    <div class="mark-body">
      <div>
        <h2>重现赛批改</h2>
        <el-divider></el-divider>
      </div>
      <div class="mark-header">
        <div class="mark-header-left" style="width: 700px;">
          <div class="paper-title">
            <h2>{{subjectObj.paper_title}}</h2>
          </div>
          <div>
            <span>总分值：{{subjectObj.total_score}}</span> |
            <span>已交：{{subjectObj.yes_submit}}人</span>
          </div>
        </div>
        <div class="mark-header-right">
          <span>{{subjectObj.not_read}}</span>个待批
        </div>
      </div>
      <div class="mark-middle">
        <div class="mark-search">
          <el-input placeholder="搜索" v-model.trim="searchValue" @input="searchName">
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input>
        </div>
        <div class="mark-classify">
          <el-select v-model="classifyValue" placeholder="请选择" @change="selectClassify">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </div>

      </div>
      <div class="mark-table">
        <el-table ref="singleTable" :data="tableData" style="width: 100%;border: 1px solid #ebeef5;" :header-cell-style="{background:'#f5f5f5',color:'#555'}">
          <el-table-column type="index" width="50"></el-table-column>
          <el-table-column property="student_name" label="参赛者" width="150">
            <template slot-scope="scope">
              {{user_role===2||is_published?scope.row.student_name:'匿名'}}
            </template>
          </el-table-column>
          <el-table-column label="状态" width="100">
            <template slot-scope="scope">{{scope.row.status | jugeStatus(scope.row.is_examines)}}</template>
          </el-table-column>
          <el-table-column property="submit_time" label="交卷时间" width="198">
            <template slot-scope="scope">
              {{user_role===2||is_published?timestampToTime(scope.row.submit_time):'隐藏'}}
            </template>
          </el-table-column>
          <el-table-column property="score" label="分数" width="100">
            <template slot-scope="scope" v-if="scope.row.is_examines">{{scope.row.score}}</template>
          </el-table-column>
          <el-table-column property="sort" label="次数" width="90">
            <template slot-scope="scope">
              {{scope.row.times}}
            </template>
          </el-table-column>
          <el-table-column property="score" label="批阅人" width="150">
            <template slot-scope="scope">{{scope.row.teacher_id}}</template>
          </el-table-column>
          <el-table-column label="操作" width="100">
            <template slot-scope="scope">
              <el-button type="text" v-if="scope.row.status===2&&scope.row.is_examines===1" @click="readResult(scope.row.student_id,scope.row.times)">查看</el-button>
              <el-button type="text" v-else-if="scope.row.status===2&&scope.row.is_examines===1" @click="readPaper(scope.row.student_id,scope.row.times)">查看</el-button>
              <el-button type="text" v-else-if="scope.row.status===2&&scope.row.is_examines===0" style="color: red;" @click="readPaper(scope.row.student_id,scope.row.times)">批阅
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10,20,50,100,200]"
          :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalSize"></el-pagination>
      </div>
    </div>
  </el-container>
</template>

<script>
import {
  replayMarkList,
  publishedResultsData,
  teacherRemindTestData
} from "@/api/show";
import { isArray } from 'util';
import Common from '@/utils/common';
export default {
  data() {
    return {
      competitionId: "", //教师发布到班级的id
      user_role: "", //是否是创建者
      is_published: "", //是否已公布答案
      classifyValue: "",
      searchValue: "", //搜索内容
      searchData: "", //搜索结果
      subjectObj: {},
      tableData: [], //分页前的数据
      pageSize: 20, //设置每页显示条目个数为20
      totalSize: 0, //总个数
      currentPage: 1, //设置当前页默认为1
      stuSort: [], //已批阅学生排名
      options: [
        { value: "", label: "全部" },
        { value: 3, label: "已批阅" },
        { value: 2, label: "待批阅" },
        { value: 1, label: "未提交" }
      ]
    };
  },
  created() {
    if (Object.keys(this.$route.params).length > 0) {
      this.competitionId = this.$route.params.competitionId;
      sessionStorage.setItem('competitionId', this.competitionId)
    } else {
      this.competitionId = sessionStorage.getItem('competitionId')
    }
  },
  mounted() {
    sessionStorage.removeItem('info')
    this.initData();
  },
  computed: {

  },
  methods: {
    //数据初始化
    initData: function () {
      let params = {
        competition_id: this.competitionId,
        key: this.searchValue,
        type: this.classifyValue,
        pageSize: this.pageSize,
        pageNo: this.currentPage
      };
      replayMarkList(params).then(response => {
        this.tableData = response.data;
        this.subjectObj = response.paper_info;
        this.user_role = response.paper_info.user_role;
        this.is_published = response.paper_info.is_published;
        this.totalSize = response.paper_info.total;
      });
    },

    sort: function (id) {
      let index = this.stuSort.findIndex(val => {
        return val.id === id;
      });
      return index + 1;
    },
    //搜索名字
    searchName: function () {
      if (this.user_role !== 2 && !this.is_published) {
        return true;
      }
      this.initData()
    },
    //切换学生状态
    selectClassify: function () {
      this.initData()
    },
    //查看成绩
    readResult: function (id, times) {
      this.$router.push({
        name: "competition-result",
        params: {
          competitionId: this.competitionId,
          studentId: id,
          times: times,
          replay_type: 1,
          classroom_id: 0
        }
      });
    },
    //老师批阅试卷,id为学生该试卷的id
    readPaper: function (id, times) {
      this.$router.push({
        name: "correct-papers",
        params: {
          competitionId: this.competitionId,
          studentId: id,
          times: times,
          replay_type: 1,
          classroom_id: 0
        }
      });
    },

    //判断是否缺考
    isExamine: function () {
      let currentTime = Date.parse(new Date()) / 1000;
      let status = 1;
      if (currentTime >= this.subjectObj.end_time) {
        status = 2;
      }
      return status;
    },
    //判断是否创建者，考试是否结束，限制权限
    isCreator: function () {
      let currentTime = Date.parse(new Date()) / 1000;
      return this.isCreator || currentTime >= this.end_time;
    },
    closeWin: function () {
      window.close();
    },
    //切换分页
    handleCurrentChange: function (page) {
      this.currentPage = page;
      this.initData();
    },
    handleSizeChange: function (val) {
      this.pageSize = val;
      this.initData();
    },
    timestampToTime: function (val) {
      if (val) {
        return Common.timestampToTime(val);
      }
    }
  },
  filters: {
    jugeStatus: function (status, type) {
      if (status === 0 || status === 1) {
        return "未提交";
      }
      if (type) {
        if (status === 1) {
          return "未提交";
        } else if (status === 2) {
          return "已批阅";
        }
      } else {
        if (status === 1) {
          return "未提交";
        } else if (status === 2) {
          return "待批阅";
        }
      }
    },

  }
};
</script>

<style scoped="">
@import url("../../assets/css/show.css");
</style>